import React, { useState } from 'react';
import './MessageActions.css';

const MessageActions = ({ message, onCopy, onRegenerate, isBot }) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(message);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
            if (onCopy) onCopy();
        } catch (err) {
            // Failed to copy text
        }
    };

    const handleShare = async () => {
        if (navigator.share) {
            try {
                await navigator.share({
                    title: 'Chat Message',
                    text: message
                });
            } catch (err) {
                // Error sharing
            }
        } else {
            // Fallback to copy
            handleCopy();
        }
    };

    return (
        <div className="message-actions">
            <button 
                className="message-action-button copy-button"
                onClick={handleCopy}
                title={copied ? "Copied!" : "Copy message"}
            >
                {copied ? (
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <polyline points="20,6 9,17 4,12"></polyline>
                    </svg>
                ) : (
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                        <path d="M5,15H4a2,2 0 0,1 -2,-2V4a2,2 0 0,1 2,-2H13a2,2 0 0,1 2,2v1"></path>
                    </svg>
                )}
            </button>

            <button
                className="message-action-button share-button"
                onClick={handleShare}
                title="Share message"
            >
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="18" cy="5" r="3"></circle>
                    <circle cx="6" cy="12" r="3"></circle>
                    <circle cx="18" cy="19" r="3"></circle>
                    <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
                    <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
                </svg>
            </button>

            {isBot && onRegenerate && (
                <button
                    className="message-action-button regenerate-button"
                    onClick={onRegenerate}
                    title="Regenerate response"
                >
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <polyline points="23,4 23,10 17,10"></polyline>
                        <polyline points="1,20 1,14 7,14"></polyline>
                        <path d="M20.49,9A9,9 0 0,0 5.64,5.64L1,10m22,4l-4.64,4.36A9,9 0 0,1 3.51,15"></path>
                    </svg>
                </button>
            )}
        </div>
    );
};

export default MessageActions;